export const GET_OFFICE_LIST = "GET_OFFICE_LIST";
export const OFFICE_PROCESSING = "OFFICE_PROCESSING";
export const STOP_OFFICE_PROCESSING = "STOP_OFFICE_PROCESSING";
